export const environment = {
  production: false,
  apiBaseUrl: 'https://keeperoon.znonasharu.org.ua/api',
  telegramWebAppPath: '/',
  telegramVerifyEndpoint: '/auth/telegram/verify',
  telegramBotUsername: 'keeperoon_bot',
  telegramMiniAppShortName: 'directlink'
} as const;
